var config = {
    tcpaText: "By clicking 'View My Quote', I expressly consent to receive marketing communications, including via calls using an automatic telephone dialing system and artificial or pre-recorded messages, emails, and text messages (SMS), from insurance companies or their agents, the owner of this website and its agents, live operators, representatives and affiliates, and partner companies, at the wireless/landline/voip telephone number xxxxxxxxxx and email address xxxxxxxxxx. I am providing this express written consent notwithstanding any current or prior election on the Do Not Call registry or anywhere else to opt in or opt out of receiving telemarketing calls or SMS messages from Avenge Digital LLC, its agents, representatives and affiliates, and its partner companies. I understand that my consent to receive communications in this manner is not required as a condition of purchasing any goods or services, my telephone company may impose charges for these contacts, and I can revoke my consent at any time. I further agree to the Terms and Conditions and Privacy Policy.",
    defaultMakes: [ "Acura", "Alfa Romeo", "AM General", "Aston Martin", "Audi", "Bentley", "BMW", "Bugatti", "Buick", "Cadillac", "Chevrolet", "Chrysler", "Daewoo", "Dodge", "Eagle", "Ferrari", "FIAT", "Fisker", "Ford", "Genesis", "Geo", "GMC", "Honda", "HUMMER", "Hyundai", "INFINITI", "Isuzu", "Jaguar", "Jeep", "Kia", "Lamborghini", "Land Rover", "Lexus", "Lincoln", "Lotus", "Maserati", "Maybach", "Mazda", "McLaren", "Mercedes-Benz", "Mercury", "MINI", "Mitsubishi", "Nissan", "Oldsmobile", "Panoz", "Plymouth", "Pontiac", "Porsche", "Ram", "Rolls-Royce", "Saab", "Saturn", "Scion", "smart", "Spyker", "Subaru", "Suzuki", "Tesla", "Toyota", "Volkswagen", "Volvo" ]
};

// try to load settings from AvengeDigitalWidgetSettings
var settings = window.AvengeDigitalWidgetSettings || null;
if (settings) {
    // required
    config.siteId = settings.siteId;
    config.subId = settings.subId;
    config.leadCampaignId = settings.leadCampaignId;
    config.apiKey = settings.apiKey;
    config.redirectUrlDefault = settings.redirectUrlDefault;
    config.redirectUrlBase = settings.redirectUrlBase;
    config.privacyPolicyUrl = settings.privacyPolicyUrl;
    config.termsAndConditionsUrl = settings.termsAndConditionsUrl;
    config.partnersUrl = settings.partnersUrl;
    config.avengeDigitalWidgetYearMakeModelTrimsScriptUrl = settings.avengeDigitalWidgetYearMakeModelTrimsScriptUrl;
    config.callUsPhoneNumber = settings.callUsPhoneNumber;
    config.googleAnalyticsTrackingId = settings.googleAnalyticsTrackingId;
    config.queryLeadInfo = settings.queryLeadInfo;
    config.vinStepAllowSkip = settings.vinStepAllowSkip;

    // optional
    config.title = settings.title;

    // optional with defaults
    config.requestTimeoutInMilliseconds = settings.requestTimeoutInMilliseconds || 1000 * 5;
    config.localStorageExpirationInMilliseconds = settings.localStorageExpirationInMilliseconds || 1000 * 60 * 60 * 24;
    config.apiUrl = settings.apiUrl || "https://www.avengehub.com";

    // defaults
    config.debug = false;
}
// defaults (for testing)
else {
    config.siteId = "testing";
    config.subId = "v1";
    config.redirectUrlDefault = "https://priceshopinsurance.com/thank-you/";
    config.redirectUrlBase = "https://priceshopinsurance.com/";
    config.privacyPolicyUrl = "https://autohomeinsure.com/contact/";
    config.termsAndConditionsUrl = "https://autohomeinsure.com/contact/";
    config.partnersUrl = "https://www.quotelab.com/marketing-partners.html";
    config.avengeDigitalWidgetYearMakeModelTrimsScriptUrl = "https://s3.amazonaws.com/avengedigital.production.widget/js/AvengeDigitalWidgetYearMakeModelTrimsV5.js.gz";
    //config.title = "Get My Quote";
    config.callUsPhoneNumber = "+16085762305";
    config.googleAnalyticsTrackingId = "UA-156596720-1";
    config.queryLeadInfo = false;
    config.requestTimeoutInMilliseconds = 1000 * 60;
    config.localStorageExpirationInMilliseconds = 1000 * 60; // 1 minute
    config.vinStepAllowSkip = true;

    if (process.env.NODE_ENV === "production") {
        config.leadCampaignId = 4;
        config.apiUrl = "https://www.avengehub-test1.fun";
        config.apiKey = "6bd8c0df1da040e09d0bd78ab013aa8a";
        config.debug = false;
    }
    else {
        config.leadCampaignId = 5;
        config.apiUrl = "http://localhost";
        //config.apiUrl = "https://www.avengehub-test1.fun:4444";
        config.apiKey = "7c74093f2ba24678908de7c9190dc5b6";
        //config.apiKey = "6bd8c0df1da040e09d0bd78ab013aa8a";
        config.debug = true;
    }
}

export { config }
